
import { NgModule } from '@angular/core';

import { SendingToFinanceEditProvider } from './sending-to-finance-edit.provider';
import { SendingToFinanceListProvider } from './sending-to-finance-list.provider';

export * from './sending-to-finance-edit.provider';
export * from './sending-to-finance-list.provider';

export {
  SendingToFinanceListProvider,
  SendingToFinanceEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    SendingToFinanceEditProvider,
    SendingToFinanceListProvider
  ]
})
export class SendingToFinanceBackendModule { }
